// rgba
export const ACCENT_COLOR = [69, 187, 198, 200]
export const ACCENT_COLOR_100 = [69, 187, 198, 65]
export const PRIMARY_COLOR = [165, 165, 165, 200]